import React, {Component} from 'react';

class NotFound404 extends Component<*> {
    render()
    {
        return (
            <div className="not-found-page">
                <span className="not-found-text">Pagina inexistenta</span>
                <span className="text-center nf">404</span>
            </div>
        );
    }
}

export default NotFound404;



// WEBPACK FOOTER //
// ./src/SHARED/components/notfound/notfound.component.js